import { render, staticRenderFns } from "./MapIconVtb.vue?vue&type=template&id=3439e66f&scoped=true&"
import script from "./MapIconVtb.vue?vue&type=script&lang=js&"
export * from "./MapIconVtb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3439e66f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3439e66f')) {
      api.createRecord('3439e66f', component.options)
    } else {
      api.reload('3439e66f', component.options)
    }
    module.hot.accept("./MapIconVtb.vue?vue&type=template&id=3439e66f&scoped=true&", function () {
      api.rerender('3439e66f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconVtb.vue"
export default component.exports